import React from "react";
import { Modal } from "react-bootstrap";
import GradientButton from "../../../Core/GradientButton";
import { useSessionStore } from "../../../../Stores/SessionStore";

export default function ConfirmAddressModal({ show, onClose }) {
	const store = useSessionStore();
	const serviceId = store.CustomerDetails?.Address?.ServiceId;

	return (
			<Modal show={ show } size="lg">
				<Modal.Header>
					<h3>
						Confirm Address
					</h3>
				</Modal.Header>
				<Modal.Body>
					<p className="mb-0">Please confirm that you are recharging for the service located at:</p>
					{serviceId && (
						<>
							<p className="mb-1 mt-3 font-weight-bold">Service ID</p>
							<p className="mb-0">{`ZNG ${serviceId}`}</p>
						</>
					)}
				</Modal.Body>
				<Modal.Footer>
					<GradientButton title="OK" variant="greenYellow" onClick={() => onClose(true)} className="mb-2" />
					<GradientButton title="Cancel" variant="yellowOrange" onClick={() => onClose(false)} />
				</Modal.Footer>
			</Modal>
	)
}